module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Collaborate",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.0199332,28.199233 C16.2633815,27.977708 15.5295126,27.719377 14.8214286,27.4265937 C13.8616507,28.301409 9.4330052,30 7.67857143,30 C8.49458967,29.1428571 10.3571429,27.4285714 10.3571429,24.8571429 C7.01928342,22.2262444 5,18.5579678 5,14.5714286 C5,6.52385079 13.3946609,0 23.75,0 C34.1053391,0 42.5,6.52386153 42.5,14.5714286 C42.5,15.8068382 42.3439929,16.9556905 42.0557038,18.0209557 C28.7954102,17.5239258 19.8779297,23.2629395 17.0199332,28.199233 Z M40,58.8571429 C29.4188291,58.8571429 15,53.1428571 15,39.4285714 C15,28.698482 26.1928813,20 40,20 C53.8071187,20 65,28.6984677 65,39.4285714 C65,44.7439571 62.3076221,49.6349926 57.8571429,53.1428571 C57.8571429,56.5714286 60.3405471,58.8571429 61.4285714,60 C59.0893264,60 53.1844657,57.7352121 51.9047619,56.5687916 C48.3502543,58.0385331 44.3084254,58.8571429 40,58.8571429 Z M40,42 C41.1045695,42 42,41.1045695 42,40 C42,38.8954305 41.1045695,38 40,38 C38.8954305,38 38,38.8954305 38,40 C38,41.1045695 38.8954305,42 40,42 Z M49,42 C50.1045695,42 51,41.1045695 51,40 C51,38.8954305 50.1045695,38 49,38 C47.8954305,38 47,38.8954305 47,40 C47,41.1045695 47.8954305,42 49,42 Z M31,42 C32.1045695,42 33,41.1045695 33,40 C33,38.8954305 32.1045695,38 31,38 C29.8954305,38 29,38.8954305 29,40 C29,41.1045695 29.8954305,42 31,42 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ce4af22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/collaborate.vue
// module id = 653
// module chunks = 1